import React from "react";
import classnames from "classnames";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { connect } from "react-redux";
import { REDUCER_KEY } from "redux-windowsize";

class IconRelatedIconsBase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0
        };

        this.handleLeftClick = this.handleLeftClick.bind(this);
        this.handleRightClick = this.handleRightClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.icon) {
            if (!this.props.icon || nextProps.icon.id != this.props.icon.id) {
                this.setState({
                    offset: 0,
                    reversed: false
                });
            }
        }
    }

    handleLeftClick(evt) {
        let offset = Math.max(this.state.offset - this.props.limit, 0);

        if (offset != this.state.offset) {
            this.props.paginate(offset);
            this.setState({
                offset,
                reversed: true
            });
        }
    }
    handleRightClick(evt) {
        let total = this.props.data.relatedIcons
            ? this.props.data.relatedIcons.totalCount
            : 0;
        let offset = Math.min(
            this.state.offset + this.props.limit,
            total - this.props.limit
        );
        if (offset != this.state.offset) {
            this.props.paginate(offset);
            this.setState({
                offset,
                reversed: false
            });
        }
    }
    canLeft(offset, limit) {
        return offset - limit >= 0;
    }
    canRight(offset, limit, total) {
        return offset + limit <= total - limit;
    }
    render() {
        let { icon, data } = this.props;

        let total = this.props.data.relatedIcons
            ? this.props.data.relatedIcons.totalCount
            : 0;

        let sourceIcon = icon;
        let icons = [],
            viewMoreIcons = data.relatedIcons && data.relatedIcons.icons;

        if (sourceIcon && viewMoreIcons) {
            icons = viewMoreIcons.map(icon => {
                let iconLink;

                if (!sourceIcon.collection) {
                    // Related icons are from user
                    if (icon.uploader === undefined) {
                        iconLink = icon.permalink;
                    } else {
                        iconLink = `/${icon.uploader.username}/uploads/?i=${
                            icon.id
                        }`;
                    }
                } else {
                    // Related icons are in collection
                    let collectionName =
                        sourceIcon.collection.name
                            .toLowerCase()
                            .indexOf("collection") >= 1
                            ? sourceIcon.collection.name
                            : sourceIcon.collection.name + " Collection";

                    iconLink = `/${
                        sourceIcon.collection.author.username
                    }/collection/${sourceIcon.collection.slug}/?i=${icon.id}`;
                }

                return (
                    <div key={icon.id} className="related-icon">
                        <a href={iconLink}>
                            <img
                                style={{
                                    width: "42px",
                                    margin: "auto",
                                    display: "block"
                                }}
                                src={icon.previewUrl}
                                title={icon.term}
                            />
                        </a>
                    </div>
                );
            });
        } else {
            // Show loading icons
            let i;
            for (i = 0; i < 4; i++) {
                icons.push(
                    <div
                        key={i}
                        className="loading-icon-placeholder"
                        style={{
                            display: "block",
                            width: "42px",
                            height: "42px",
                            borderRadius: "50%",
                            backgroundColor: "#f2f2f2"
                        }}
                    />
                );
            }
        }

        let leftClass = classnames("view-more_arrow left-arrow ui_left-arrow", {
            disabled: !this.canLeft(this.state.offset, this.props.limit)
        });
        let rightClass = classnames(
            "view-more_arrow right-arrow ui_right-arrow",
            {
                disabled: !this.canRight(
                    this.state.offset,
                    this.props.limit,
                    total
                )
                // disabled: (this.state.viewMoreOffset + 4) / 4 === Math.ceil(totalCount / 4)
            }
        );

        let classes = classnames(
            "icon-view-more view-more animate",
            this.props.className,
            {
                reversed: this.state.reversed
            }
        );

        return (
            <div className={classes}>
                <h3 className="padding-b-s">You may also like:</h3>
                <div
                    className="view-more-container"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "#FAFAFA",
                        padding: "24px 12px",
                        border: "solid 1px #F2F2F2",
                        height: "100px",
                        width: "100%"
                    }}
                >
                    <div
                        className={leftClass}
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={this.handleLeftClick}
                    />
                    {icons}
                    <div
                        className={rightClass}
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={this.handleRightClick}
                    />
                </div>
            </div>
        );
    }
}

IconRelatedIconsBase.defaultProps = {
    limit: 10,
    offset: 0
};

const iconListQuery = gql`
    query IconMoreLikeThis($iconId: ID, $offset: Int, $limit: Int) {
        relatedIcons(iconId: $iconId, offset: $offset, limit: $limit) {
            icons {
                id
                uploader {
                    fullName
                    username
                    permalink
                }
                collections {
                    name
                    author {
                        username
                    }
                    slug
                }
                previewUrl
                term
            }
            totalCount
        }
    }
`;

const IconRelatedIcons = graphql(iconListQuery, {
    options: props => {
        let { icon, iconId } = props;

        iconId = (icon && icon.id) || iconId;

        return {
            variables: {
                iconId,
                limit: props.limit,
                offset: props.offset
            }
        };
    },
    props: ({ ownProps, data }) => {
        let { icon, limit, iconId } = ownProps;
        let { fetchMore } = data;

        iconId = (icon && icon.id) || iconId;

        return {
            data,
            ...ownProps,
            paginate: offset => {
                return fetchMore({
                    variables: {
                        iconId: iconId,
                        offset: offset,
                        limit: limit
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return fetchMoreResult;
                    }
                });
            }
        };
    }
})(IconRelatedIconsBase);

function mapStateToProps(state, props) {
    let viewport = state[REDUCER_KEY];
    if (viewport) {
        let { width } = viewport;
        let unusableSpace = 24 + 36; // padding + arrows
        let iconSizeWithPadding = 42 + 10;
        let limit = Math.min(
            Math.floor((width - unusableSpace) / iconSizeWithPadding),
            10
        );

        limit = Math.max(limit, 1);
        return {
            limit
        };
    }

    return {};
}

export default connect(
    mapStateToProps,
    {}
)(IconRelatedIcons);
